// utils/safeNext.js
// Where to send someone after login / sign-up when a link carries ?next=…
// (e.g. the DWI Market page's "Sign up to buy" → /register?next=/market).
// Only in-app DWI Market paths are allowed — never an outside site or any
// other page — so a crafted link can't redirect a user somewhere unexpected.
const ALLOWED = /^\/market(\?[A-Za-z0-9=&_%-]*)?$/;

export function safeNext(raw, fallback = '/dashboard') {
  return typeof raw === 'string' && ALLOWED.test(raw) ? raw : fallback;
}

// Carry ?next= over to the other auth page ("Already have an account? Log in").
export function withNext(path, raw) {
  const next = safeNext(raw, '');
  return next ? `${path}?next=${encodeURIComponent(next)}` : path;
}
